import React, { useState, useEffect, useContext } from 'react'
import SglContext from '../SglContext';
import { Link } from 'react-router-dom';
import Flickity from "react-flickity-component";
import watch_live from "../images/watch-live.png"
import watch_video from "../images/watch-video.png"
import './flickity.css'
import "./liveStream.css";

var moment = require('moment');
const axios = require("axios").default;

const flickityOptions = {
    cellAlign: 'left',
    contain: true,
    pageDots: false,
    prevNextButtons: true,
}

export default function LiveStream() {

    const [live_now_events, setLiveNowEvents] = useState([]);
    const Sgl = useContext(SglContext)
    const switch_company_name = Sgl.switches.company_name ? Sgl.switches.company_name : "The Company"
    const special_events = Sgl.switches['switches'].find((element) => {
        return element['switch_name'] == 'Videos - Special Events Live Streaming'
    })
    const special_events_switch = special_events.value

    useEffect(() => {
        getAllData();
    }, []);

    const getAllData = () => {
        const formData = new URLSearchParams();
        formData.append('customer_id', Sgl.company_id);
        formData.append('limit', 30);

        axios.post(Sgl.nestApiUrl + '/livestream/getLiveNowLivestreams', formData, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then(res => {
            setLiveNowEvents(res.data);
        }).catch(error => {
            console.error('Error fetching live now livestreams:', error);
        });
    }
    return (
        <div>
            <section className="search-area">
            {(special_events_switch != 1) ?
                <>
                    <h2 className="sgl-h2" style={{ marginTop: "10px" }}>Special Events Live Streaming</h2>
                    <p>{switch_company_name} does not support this feature</p>
                </>
                :
                <>
                    <h2 className="sgl-h2" style={{ marginTop: "10px" }}>Special Events Live Streaming</h2>
                    <Flickity
                        className={'sgl-live-now-carousel carousel'}
                        elementType={'div'}
                        options={flickityOptions}
                    >
                        {live_now_events.map((live_event, index) =>

                            <div key={index} className="sgl-banner sgl-live-now-banner" style={{ position: "absolute" }} aria-hidden="true">
                                <div className="sgl-banner-inner sgl-fill">
                                    <div className="sgl-banner-bg sgl-fill">
                                        <div className="sgl-fill sgl-bg-loaded"></div>
                                    </div>
                                    <div className="is-sgl-border"></div>
                                    <div className="sgl-banner-layers">
                                        <div className="sgl-fill banner-link"></div>
                                        <div className="sgl-banner-image" style={{ backgroundImage: "url(" + live_event.placeholder_image + ")" }}></div>
                                        <div className="sgl-live-now-text">
                                            <div data-animate="blurIn" data-animated="true">
                                                <div className="sgl-text-box-content">
                                                    <div className="sgl-text-inner">
                                                        <h2>{live_event.title}</h2>
                                                        <div className="is-sgl-divider"></div>
                                                        {(live_event.event_type == "live") &&
                                                            <>
                                                                <Link className="sgl-carousel-button click" to={"/livestream/detail?se_id=" + live_event.sgl_id}>
                                                                    <span>
                                                                        <img src={watch_live} style={{ width: " 22px", marginTop: "-3px", marginRight: "3px" }} />
                                                                        WATCH IT LIVE
                                                                        <svg style={{ width: "16px", height: "16px", position: "absolute", top: "12.2px", left: "19.5px" }}>
                                                                            <circle fill="#E10600" stroke="none" cx="8" cy="8" r="5">
                                                                                <animate attributeName="opacity" dur="2s" values="0;1;0" repeatCount="indefinite" begin="0.1" />
                                                                            </circle>
                                                                        </svg>
                                                                    </span>

                                                                </Link>
                                                                <div>
                                                                    <h3>EVENT STARTED AT {moment(live_event.event_date + " " + live_event.event_time).format("hh[:]mm A")}</h3>
                                                                </div>
                                                            </>
                                                        }


                                                        {(live_event.event_type == "upcoming") &&
                                                            <><a className="sgl-carousel-button default">
                                                                <span>COMING SOON</span>
                                                            </a>
                                                                <div>
                                                                    <h3>EVENT STARTS AT <br className="sgl-sep" />{moment(live_event.event_date + " " + live_event.event_time).format("Do [of] MMMM YYYY hh[:]mm A")}</h3>
                                                                </div>
                                                            </>}
                                                        {(live_event.event_type == "archive" || live_event.event_type == "homepage") &&
                                                            <>

                                                                <Link className="sgl-carousel-button click" to={"/livestream/detail?se_id=" + live_event.sgl_id}>
                                                                    <span>
                                                                        <img src={watch_video} style={{ width: "24px", marginTop: "-2.7px" }} />
                                                                        PLAY VIDEO</span>
                                                                </Link>
                                                                <div>
                                                                    <h3>EVENT HELD ON <br className="sgl-sep" />{moment(live_event.event_date + " " + live_event.event_time).format("Do [of] MMMM YYYY hh[:]mm A")}</h3>
                                                                </div>
                                                            </>}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        )}
                    </Flickity>
                </>
            }
            </section>
        </div >
    )

}
